/* ===== H2YOU.CR — WaterH Vision · theme.js ===== */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- scroll reveals (with stagger among siblings) ---- */
  var reveals = document.querySelectorAll('.reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    reveals.forEach(function (el) { el.classList.add('in'); });
  } else {
    // precompute a small stagger index per element based on its position among reveal siblings
    reveals.forEach(function (el) {
      var sibs = el.parentElement ? el.parentElement.querySelectorAll(':scope > .reveal') : [el];
      var idx = Array.prototype.indexOf.call(sibs, el);
      el.__stagger = idx > 0 ? Math.min(idx, 5) * 60 : 0; // cap at 300ms total
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var d = e.target.__stagger || 0;
          if (d) e.target.style.transitionDelay = d + 'ms';
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    reveals.forEach(function (el) { io.observe(el); });
  }

  /* ---- hero parallax ---- */
  var heroImg = document.querySelector('[data-hero-img]');
  if (heroImg && !reduce) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (y < window.innerHeight) {
          heroImg.style.transform = 'translateY(' + (y * 0.06) + 'px) scale(' + (1 + Math.min(y / 4000, 0.06)) + ')';
        }
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---- count-up stats ---- */
  function countUp(el) {
    var raw = el.textContent.trim();
    if (raw.indexOf('–') > -1 || raw.indexOf('-') > -1) return; // ranges: skip
    var m = raw.match(/^([+]?)(\d+(?:[.,]\d+)?)(.*)$/);
    if (!m) return;
    var prefix = m[1], numStr = m[2], suffix = m[3];
    var dec = (numStr.indexOf('.') > -1 || numStr.indexOf(',') > -1) ? 1 : 0;
    var target = parseFloat(numStr.replace(',', '.'));
    var start = null, dur = 1100;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + (target * eased).toFixed(dec) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  if (!reduce && 'IntersectionObserver' in window) {
    var statNums = document.querySelectorAll('.stat .n');
    if (statNums.length) {
      var so = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { countUp(e.target); so.unobserve(e.target); } });
      }, { threshold: 0.5 });
      statNums.forEach(function (el) { so.observe(el); });
    }
  }

  /* ---- option labels (color/size) live update ---- */
  document.querySelectorAll('[data-opt]').forEach(function (group) {
    group.addEventListener('change', function () {
      var checked = group.querySelector('input:checked');
      var label = group.previousElementSibling;
      if (checked && label && label.classList.contains('opt-label')) {
        var val = label.querySelector('.val');
        if (val) val.textContent = checked.value;
      }
    });
  });

  /* ---- active section highlight in nav ---- */
  (function () {
    var links = Array.prototype.slice.call(document.querySelectorAll('.nav-links a[href*="#"]'));
    var map = {};
    links.forEach(function (a) {
      var hash = a.getAttribute('href').split('#')[1];
      if (hash && document.getElementById(hash)) map[hash] = a;
    });
    var ids = Object.keys(map);
    if (!ids.length || !('IntersectionObserver' in window)) return;
    var no = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          links.forEach(function (a) { a.classList.remove('active'); });
          if (map[e.target.id]) map[e.target.id].classList.add('active');
        }
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    ids.forEach(function (id) { no.observe(document.getElementById(id)); });
  })();

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('.q > button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var q = btn.parentElement;
      var open = q.classList.toggle('open');
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  /* ---- Product page ---- */
  var pdp = document.querySelector('[data-product]');
  if (pdp) {
    var dataEl = document.getElementById('ProductJson');
    var product = null;
    try { product = JSON.parse(dataEl.textContent); } catch (e) {}
    var mainImg = pdp.querySelector('[data-main-img]');
    var idInput = pdp.querySelector('[data-variant-id]');
    var priceEl = pdp.querySelector('[data-price]');
    var cmpEl = pdp.querySelector('[data-price-cmp]');
    var stockEl = pdp.querySelector('[data-stock]');
    var addBtn = pdp.querySelector('[data-add]');
    var stickyName = document.querySelector('[data-sticky-name]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyImg = document.querySelector('[data-sticky-img]');
    var moneyFormat = pdp.getAttribute('data-money') || '${{amount}}';

    function group(intStr, sep) { return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    function num(cents, dec, thou, decSep) {
      var n = (cents / 100).toFixed(dec), parts = n.split('.');
      parts[0] = group(parts[0], thou);
      return dec > 0 ? parts[0] + decSep + parts[1] : parts[0];
    }
    function formatMoney(cents) {
      var f = moneyFormat, v, ph;
      if (f.indexOf('amount_no_decimals_with_comma_separator') > -1) { ph = 'amount_no_decimals_with_comma_separator'; v = num(cents, 0, '.', ','); }
      else if (f.indexOf('amount_with_comma_separator') > -1) { ph = 'amount_with_comma_separator'; v = num(cents, 2, '.', ','); }
      else if (f.indexOf('amount_no_decimals') > -1) { ph = 'amount_no_decimals'; v = num(cents, 0, ',', '.'); }
      else if (f.indexOf('amount_with_apostrophe_separator') > -1) { ph = 'amount_with_apostrophe_separator'; v = num(cents, 2, "'", '.'); }
      else { ph = 'amount'; v = num(cents, 2, ',', '.'); }
      return f.replace(new RegExp('\\{\\{\\s*' + ph + '\\s*\\}\\}'), v);
    }

    /* thumbnails */
    pdp.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-thumb');
        if (mainImg && src) {
          mainImg.style.opacity = 0;
          setTimeout(function () { mainImg.src = src; mainImg.style.opacity = 1; }, 180);
        }
        pdp.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
      });
    });

    /* variant selection */
    function currentOptions() {
      var opts = [];
      pdp.querySelectorAll('[data-opt]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts.push(checked.value);
      });
      return opts;
    }
    function findVariant(opts) {
      if (!product) return null;
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function updateVariant(isInit) {
      if (!product) return;
      var v = findVariant(currentOptions());
      if (!v) return;
      if (idInput) idInput.value = v.id;
      // On initial load keep the server-rendered (correct) price; only reformat on user change.
      if (!isInit) {
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (cmpEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            cmpEl.textContent = formatMoney(v.compare_at_price); cmpEl.style.display = '';
          } else { cmpEl.style.display = 'none'; }
        }
      }
      if (stockEl) {
        if (v.available) { stockEl.textContent = 'En stock · listo para enviar'; stockEl.classList.remove('out'); }
        else { stockEl.textContent = 'Agotado'; stockEl.classList.add('out'); }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? (addBtn.getAttribute('data-label') || 'Agregar al carrito') : 'Agotado';
      }
      if (!isInit && v.featured_image && v.featured_image.src && mainImg) {
        mainImg.style.opacity = 0;
        setTimeout(function () { mainImg.src = v.featured_image.src; mainImg.style.opacity = 1; }, 180);
      }
      if (stickyName) stickyName.textContent = product.title + (v.title && v.title !== 'Default Title' ? ' · ' + v.title : '');
      if (stickyPrice) {
        var pr = isInit && priceEl ? priceEl.textContent : formatMoney(v.price);
        stickyPrice.textContent = pr + ' · o 2×25% OFF';
      }
    }
    pdp.querySelectorAll('[data-opt] input').forEach(function (inp) {
      inp.addEventListener('change', function () { updateVariant(false); });
    });
    updateVariant(true);

    /* quantity */
    var qIn = pdp.querySelector('[data-qty]');
    var qMinus = pdp.querySelector('[data-qty-minus]');
    var qPlus = pdp.querySelector('[data-qty-plus]');
    if (qMinus) qMinus.addEventListener('click', function () { qIn.value = Math.max(1, (parseInt(qIn.value, 10) || 1) - 1); });
    if (qPlus) qPlus.addEventListener('click', function () { qIn.value = Math.min(99, (parseInt(qIn.value, 10) || 1) + 1); });

    /* sticky buy bar */
    var sticky = document.getElementById('StickyBuy');
    var anchor = pdp.querySelector('[data-add]') || pdp.querySelector('[data-buy-panel]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.boundingClientRect.top < 0 && !e.isIntersecting) sticky.classList.add('show');
          else if (e.isIntersecting) sticky.classList.remove('show');
        });
      }, { threshold: 0 });
      so.observe(anchor);
    }
  }

  /* ---- cart drawer (AJAX add-to-cart, progressive enhancement) ---- */
  (function () {
    var drawer = document.querySelector('[data-cd]');
    var overlay = document.querySelector('[data-cd-overlay]');
    if (!drawer || !overlay) return;
    var bodyEl = drawer.querySelector('[data-cd-body]');
    var shipEl = drawer.querySelector('[data-cd-ship]');
    var totalEl = drawer.querySelector('[data-cd-total]');
    var noteEl = drawer.querySelector('[data-cd-note]');
    var SHIP = window.H2U_SHIP || { mode: 'qty', qty: 2, amount: 45000, note: '' };

    function money(cents) {
      try { return '₡' + (cents / 100).toLocaleString('es-CR', { maximumFractionDigits: 0 }); }
      catch (e) { return '₡' + Math.round(cents / 100); }
    }
    function shipState(cart) {
      if (SHIP.mode === 'off') return { hide: true, on: false, msg: '' };
      if (SHIP.mode === 'amount') {
        var th = (SHIP.amount || 0) * 100, on = cart.total_price >= th;
        return on ? { on: true, msg: '🎉 <b>¡Envío GRATIS desbloqueado!</b>' }
                  : { on: false, msg: '🚚 Te faltan <b>' + money(th - cart.total_price) + '</b> para el envío gratis.' };
      }
      var qn = SHIP.qty || 2, on2 = cart.item_count >= qn, need = qn - cart.item_count;
      return on2 ? { on: true, msg: '🎉 <b>¡Envío GRATIS desbloqueado!</b>' }
                 : { on: false, msg: '🚚 Agregá <b>' + need + ' botella' + (need !== 1 ? 's' : '') + ' más</b> y el envío te sale <b>gratis</b>.' };
    }
    function openDrawer() { overlay.classList.add('open'); drawer.classList.add('open'); document.documentElement.style.overflow = 'hidden'; }
    function closeDrawer() { overlay.classList.remove('open'); drawer.classList.remove('open'); document.documentElement.style.overflow = ''; }
    overlay.addEventListener('click', closeDrawer);
    drawer.querySelectorAll('[data-cd-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    function render(cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      var ss = shipState(cart);
      shipEl.className = ss.on ? 'cd-ship win' : 'cd-ship';
      shipEl.innerHTML = ss.hide ? '' : ss.msg;
      bodyEl.innerHTML = '';
      cart.items.forEach(function (it) {
        var row = document.createElement('div'); row.className = 'cd-item';
        var img = it.image ? '<img src="' + it.image + '" alt="">' : '';
        var vt = (it.variant_title && it.variant_title !== 'Default Title') ? esc(it.variant_title) + ' · ' : '';
        row.innerHTML = img + '<div><div class="nm">' + esc(it.product_title) + '</div><div class="vr">' + vt + 'x' + it.quantity + '</div></div><div class="pr">' + money(it.final_line_price) + '</div>';
        bodyEl.appendChild(row);
      });
      totalEl.textContent = money(cart.total_price);
      noteEl.textContent = ss.on ? 'Impuestos incluidos · Envío GRATIS aplicado.' : 'Impuestos incluidos · el envío se calcula al pagar.';
    }
    function refreshAndOpen() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { render(c); openDrawer(); })
        .catch(function () { window.location.href = '/cart'; });
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      if (!window.fetch || !window.FormData) return; // native submit fallback
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var label;
      if (btn) { label = btn.textContent; btn.disabled = true; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { refreshAndOpen(); })
        .catch(function () { form.submit(); })
        .then(function () { if (btn) { btn.disabled = false; if (label) btn.textContent = label; } });
    }, true);
  })();
})();
